module.exports = __webpack_public_path__ + "static/coufal-9f8776d6a02a78565cf059fdd373f31d.jpg";